const Mock = require('mockjs');

require('./api/layout');
require('./api/home');
require('./api/content');

Mock.mock('/api', 'get', () => {});

Mock.setup({
	timeout: 500,
});
